import { render, staticRenderFns } from "./DocumentParentsSummary.vue?vue&type=template&id=61d8ccd6&scoped=true&"
import script from "./DocumentParentsSummary.vue?vue&type=script&lang=js&"
export * from "./DocumentParentsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentParentsSummary.vue?vue&type=style&index=0&id=61d8ccd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8ccd6",
  null
  
)

export default component.exports